import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import amudanit1 from "../../../assets/images/amudanit1.jpeg";
import BackButton from "../../backButton";

const Amudanit = () => {
  return (
    <div className="inner-section" id="amudanit">
      <Helmet>
        <title>פטרידע - הפטריה עמודנית</title>
        <meta
          name="description"
          content="הפטריה עמודנית - schizostoma: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="amudanit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="amudanitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="amudanitText2" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="amudanitText3Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="amudanitText4" />
          </p>
          <br />
          <p>
            <MultiLingualContent contentID="amudanitText5" />
          </p>
        </div>
        <div className="informationImages">
          <div className="imgWrapper">
            <LazyLoadImage src={amudanit1} alt="עמודנית" />
            <p>
              <MultiLingualContent contentID="amudanitImg1" />
            </p>
          </div>
        </div>
      </>
    </div>
  );
};

export default Amudanit;
